  <div class="action-bar">
    <div class="field-button">
      <button nz-button nzType="text" (click)="expandAll(true)">{{'logintegracao.expandir'|translateTA}}</button>
      <button nz-button nzType="text" (click)="expandAll(false)">{{'logintegracao.recolher'|translateTA}}</button>
    </div>
    <div class="field-filter">
        <div class="tem-field">
          <label class="tem-field-label">Contexto</label>
          <nz-select [formControl]="filterCompany" nzMode="multiple" nzShowSearch nzAllowClear nzPlaceHolder="Contexto">
            <nz-option *ngFor="let item of companyList" [nzValue]="item.key" [nzLabel]="item.key + ' - ' + item.name"></nz-option>
          </nz-select>
        </div>
    </div>
  </div>
  <nz-collapse class="headers-align">
    <nz-collapse-panel *ngFor="let item of listSyncFiltered|async"
        [nzHeader]="panelHeader"
        [nzActive]="item.panelActive"
        (nzActiveChange)="onPanelChange(item, $event)"
        [nzShowArrow]="item.CNTOFF != 0">
      <ng-template #panelHeader>
        <div class="panel-header-row">
          <span class="panel-title">{{item.NAME==null?('logintegracao.semnome'|translateTA):item.NAME}} - {{item.RECMODIFYON}}</span>
          <span class="panel-description">
            {{item.IDJOB}}/{{item.SEQUENCE}} | {{item.CODECOMPANY}} - {{item.CODECOMPANY_NAME}} | {{item.SERVERNAME}} | {{'logintegracao.detail'|translateTA}}:{{item.CNTOFF}}
            <nz-icon nzType="thunderbolt"></nz-icon>
          </span>
        </div>
      </ng-template>
      <div *ngIf="item.open" class="expanse-detail">
        <expanse-panel [title]="itemDet.IDOFF" [startOpen]="false" *ngFor="let itemDet of item.listSyncDetail|async">
          <div class="detail-grid">
            <div class="header">{{'logintegracao.datarequisicao'|translateTA}}</div>
            <div class="header">{{'logintegracao.url'|translateTA}}</div>
            <div class="header">{{'logintegracao.header'|translateTA}}</div>
            <div class="detalhe text-overflow">{{itemDet.RECMODIFIEDON}}</div>
            <div class="detalhe text-overflow">{{itemDet.URL}}</div>
            <div class="detalhe text-overflow">{{itemDet.HEADER}}</div>
          </div>
          <nz-divider class="detail-divider"></nz-divider>
          <div class="req-grid">
            <div class="tem-field customtextarea">
                <div class="tem-field-label-row">
                    <label class="tem-field-label">{{'logintegracao.requisicao'|translateTA}}</label>
                    <button nz-button nzType="text" nzShape="circle" nzSize="small" tabindex="-1" type="button" nz-tooltip="Visualizar" (click)="openJSONPopUp(itemDet.REQUEST,'Requisição')">
                        <nz-icon nzType="eye"></nz-icon>
                    </button>
                </div>
                <textarea nz-input disabled rows="7" [(ngModel)]="itemDet.REQUEST" class="textarea-inner"></textarea>
            </div>
            <div class="tem-field customtextarea">
                <div class="tem-field-label-row">
                    <label class="tem-field-label">{{'logintegracao.retorno'|translateTA}}</label>
                    <button nz-button nzType="text" nzShape="circle" nzSize="small" tabindex="-1" type="button" nz-tooltip="Visualizar" (click)="openJSONPopUp(itemDet.RESPONSE,'Retorno')">
                        <nz-icon nzType="eye"></nz-icon>
                    </button>
                </div>
                <textarea nz-input disabled rows="7" [(ngModel)]="itemDet.RESPONSE" class="textarea-inner"></textarea>
            </div>
          </div>
        </expanse-panel>
      </div>
    </nz-collapse-panel>

  </nz-collapse>
